import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import icClose from '@iconify/icons-ic/twotone-close';
import { LayoutService } from '../../services/layout.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { catchError, debounceTime, filter, map } from 'rxjs/operators';
import { FormControl } from '@angular/forms';
import { SearchService } from '../../services/search.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'environments/environment';
import { Observable, BehaviorSubject } from 'rxjs';
import { Router } from '@angular/router';
import { MatOption } from '@angular/material/core';

export interface SearchResult {
  label: string;
  value: string;
}

@UntilDestroy()
@Component({
  selector: 'vex-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})
export class SearchComponent implements OnInit, OnDestroy {

  show$ = this.layoutService.searchOpen$;
  searchCtrl = new FormControl();
  icClose = icClose;
  baseUrl = environment.API_URL;
  filteredOptions: BehaviorSubject<SearchResult[]> = new BehaviorSubject<SearchResult[]>([]);
  selectedId = null;

  @ViewChild('searchInput', { static: true }) input: ElementRef;

  constructor(
    private layoutService: LayoutService,
    private searchService: SearchService,
    private http: HttpClient,
    private router: Router,
  ) { }

  ngOnInit() {
    this.initializeSearch();
  }

  initializeSearch(){
    this.searchService.isOpenSubject.next(true);
    this.searchCtrl.valueChanges.pipe(
      debounceTime(300),
      filter(value => value && value.length > 0),
      untilDestroyed(this)
    ).subscribe(value => {
      this.search();
    });

    this.show$.pipe(
      filter(show => show),
      untilDestroyed(this)
    ).subscribe(() => this.input.nativeElement.focus());
  }

  close() {
    this.layoutService.closeSearch();
    this.searchCtrl.setValue(undefined);
    this.searchService.isOpenSubject.next(false);
    this.filteredOptions.next([]);
  }

  search() {
    const query = this.searchCtrl.value;
    
    if (query) {
      const params = new HttpParams().set('q', query);
      this.http.get<any[]>(`${this.baseUrl}search/query`, { params }).pipe(
        catchError((error) => {
          return [];
        }),
        map((results) => {
          return results.map(result => ({
            label: result.BlueprintName,
            value: result.Id
          }));
        })
      ).subscribe((mappedResults) => {
        this.filteredOptions.next(mappedResults);
      });
    }
  }

  onOptionSelected(event: { option: MatOption }) {
    this.selectedId = event.option.value;
    const selectedValue = event.option.value;
    this.close();
    window.open('/blueprintdesigner/list?id=' + selectedValue, '_blank');
  }

  ngOnDestroy(): void {
    this.layoutService.closeSearch();
    this.searchCtrl.setValue(undefined);
    this.searchService.isOpenSubject.next(false);
  }
}
